module.exports = __webpack_public_path__ + "media/images/flags/16/Iceland-3f8993f1dae2d6455f31d4d77660bc32.png";